export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
    },
    searchInput: {
      border: `1px solid ${theme?.palette?.divider}`,
      borderRadius: '4px',
      flexShrink: 0,
      fontSize: '16px',
      height: '40px',
      px: '12px',
      width: '100%',
      boxSizing: 'border-box',
      '&:focus-within': {
        borderColor: 'primary.main',
        borderWidth: '1px',
      },
    },
    searchIcon: {
      color: isDark ? '#FFFFFF8F' : '#231F298F',
      mr: '10px',
    },
    searchResults: {
      flex: 1,
      listStyle: 'none',
      minHeight: 0,
      m: 0,
      p: 0,
      mt: '0.5rem',
      mx: '0.25rem',
      overflowY: 'auto',
      overscrollBehaviorY: 'contain',
    },
    searchResultRow: {
      flexShrink: 0,
      py: '0.5rem',
    },
    assignedStudentsList: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      listStyle: 'none',
      minHeight: 0,
      m: 0,
      p: 0,
      mt: '0.5rem',
      mx: '0.25rem',
      overflowY: 'auto',
      overscrollBehaviorY: 'contain',
    },
    assignedStudentRow: {
      flexShrink: 0,
      py: '0.5rem',
    },
    listItem: {
      listStyle: 'none',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px',
    },
  };
};
